.select-alt-label {
  font-weight: 500;
}

.select-alt-container {
  font-family: 'Lato';
  font-weight: 400;
  transition: all 0.25 ease-in-out;
  position: relative;
  background: transparent;
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;

  .input-container {
    display: flex;
    align-items: center;

    .multi-container {
      display: flex;
      align-items: center;
      padding-top: 8px;
      padding-bottom: 8px;
      padding-left: 12px;

      .multi-value {
        display: flex;
        align-items: center;
        background-color: var(--gray-100);
        margin-right: 6px;
        padding: 2px 4px;

        .multi-value-label {
          white-space: nowrap;
          font-size: 12px;
          font-weight: 400;
        }

        span {
          padding-left: 4px;
          font-size: 14px;
          font-weight: bold;
          cursor: pointer;
        }
      }
    }

    .select-input {
      background-color: transparent;
      border: none;
      padding: 10px 12px;
      outline: 0;
      width: 100%;
      cursor: pointer;

      &:disabled {
        cursor: not-allowed;
      }
    }
  }

  .select-alt-options {
    position: absolute;
    top: 120%;
    left: 0;
    width: 100%;
    background-color: white;
    box-shadow: 0px 3px 12px rgba($color: #000000, $alpha: 0.1);
    z-index: 999999;
    border-radius: 4px;

    .option {
      padding: 8px 12px;
      background-color: transparent;
      position: relative;

      &:hover {
        &::after {
          background-color: var(--action-default);
          opacity: 0.2;
          display: block;
          content: '';
          width: 100%;
          height: 100%;
          z-index: -2;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
    }
  }

  .select-alt-icon {
    position: absolute;
    top: 50%;
    right: 12px;
    color: var(--primary-main);
    pointer-events: none;
    transform: translateY(-40%);
  }

  .select-alt-close-icon {
    position: absolute;
    top: 50%;
    right: 34px;
    color: var(--primary-main);
    transform: translateY(-40%);
    cursor: pointer;
  }

  &.disabled {
    background-color: rgba($color: #000000, $alpha: 0.05);
    cursor: not-allowed;
  }
}
